var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('el-menu',{staticClass:"el-menu-vertical-demo full-height",attrs:{"default-active":_vm.$route.meta[0].url+'/'+_vm.$route.meta[1].url,"router":_vm.routerMode,"background-color":"#141414","text-color":"#666666","active-text-color":"#ffffff"},on:{"select":_vm.handleSelect}},[_vm._t("trademark"),_vm._t("router")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }